





















































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { PaymentFrequency, PeriodicService } from '@/data/models/periodicservice.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Search } from '@/data/models/search.model';
import { Actor } from '@/data/models/actor.model';
import { Veicolo } from '@/data/models/veicolo.model';
import { currencyToNumber, newDate, numberMask } from '@/data/utils/helper';
import { Tipologiaintervento } from '@/data/models/tipologiaintervento.model';
import { Contatto } from '@/data/models/contatto.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	},
})

export default class ServizioPeriodicoDatiServizio extends Vue {
	@Prop() periodicservice!: PeriodicService;
	@Prop() editable!: boolean;
	@Prop() hqid!: number;

	actorClass: ClassType<Actor> = Actor;
	actorSearch: Search = new Search('actor');
	operatoreClass: ClassType<Actor> = Actor;
	operatoreSearch: Search = new Search('actor');
	veicoloClass: ClassType<Veicolo> = Veicolo;
	veicoloSearch: Search = new Search('vehicle');
	payerClass: ClassType<Actor> = Actor;
	payerSearch: Search = new Search('actor');
	interventoClass: ClassType<Tipologiaintervento> = Tipologiaintervento;

	paymentFreqs!: any[];

	numberMask: any = numberMask();

	currencies: any = {};

	constructor() {
		super();
		this.actorSearch.addNotEqualFilter('patientid', null);
		this.actorSearch.addSimpleFilter('hqid', this.hqid);
		this.payerSearch.addSimpleFilter('hqid', this.hqid);
		this.veicoloSearch.addSimpleFilter('hqid', this.hqid);
		this.operatoreSearch.addSimpleFilter('hqid', this.hqid);
		this.operatoreSearch.addSimpleFilter('candrive', 1);
		this.operatoreSearch.addNotEqualFilter('volunteerid', null);
	}

	created() {
		this.paymentFreqs = Object.keys(PaymentFrequency).filter((k: any) => isNaN(k)).map((k: any) => ({ 
			label: this.$t('payment-freq.' + k.toLowerCase()) as string,
			value: PaymentFrequency[k]
		}));
		this.periodicservice.bookingdate = newDate();
	}

	mounted() {
		const refsList: string[] = [
			'driver', 
			'vehicle', 
			'payer', 
			'seconddriver',
			'patient',
			'pickup',
			'dropoff'
		];
		for (const r of refsList) {
			// @ts-ignore
			if (this.$refs[r] && this.periodicservice[r]) {
				// @ts-ignore
				this.$refs[r].autocomplete.setSelected(this.periodicservice[r]);
			}
		}
	}

	onAddPatientAddress(key: string) {
		// set pickup/dropoff to patient address
		this.$set(this.periodicservice, key, this.periodicservice.patient?.fullAddress);
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.periodicservice, k, this.currencies[k]);
		});
		this.$emit('submit');
	}

	contactFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.address ? contact.address : ''} ${contact.streetno ? contact.streetno : ''}`;
		}
	}

	operatoreFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
	}

}
